import * as React from "react"
import { Table, TableBody, TableRow, TableCell, TableHead, Button, Grid } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { getLocalStorageValue } from 'src/effects/utils/local-storage';
import { UserType } from 'src/constants/Enum/UserType';

export default class RegionCountryInfoComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
        }

        this.gotoResponses = this.gotoResponses.bind(this)
        this.downloadProgressReport = this.downloadProgressReport.bind(this)
    }
    gotoResponses() {
        this.props.gotoResponses(false);
    }

    downloadProgressReport() {
        this.props.downloadProgressReport();
    }

    render() {
        const loggedInUser = getLocalStorageValue('user');
        const assignCoutry = this.props.regionData.length;
        const countryList: any[] = [];
        let isGIAvailable: boolean = false;
        let giColumnTotal: number = -1
        for (let i = 0; i < assignCoutry; i++) {
            this.props.regionData[i].countryAndModuleTypeData.map((country: any, key: any) => {
                giColumnTotal += giColumnTotal;
                countryList.push(country)
            })
        }
        
        if (this.props.regionData && this.props.regionData.length > 0) {
            isGIAvailable = this.props.regionData.filter((x: any) => x.giPercentage >= 0).length > 0 ? true : false;
        }
         
        return (
            <Grid item={true} xs={4} lg={6} xl={6} className="mediaWidth100">
                <div className="contentRightSection">
                    <Table className="countryInfo">
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <span>{loggedInUser.roleId === UserType.DataCollector ? "Countries" : "Regions"}</span>
                                </TableCell>
                                {
                                    (!isGIAvailable || giColumnTotal === -1) ? '' : <TableCell> <span>G.I.</span> </TableCell>
                                }
                                <TableCell>
                                    <span>Cov.</span>
                                </TableCell>
                                <TableCell>
                                    <span>Fore.</span>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loggedInUser.roleId === UserType.DataCollector ?
                                (countryList && countryList.map((country: any, key: any) => {

                                    return <TableRow key={key}>
                                        <TableCell>
                                            <span>{country.name}</span>
                                        </TableCell>
                                        {
                                            (!isGIAvailable || giColumnTotal === -1) ? '' : <TableCell> {country.countryModuleMappingId !== 0 ? <span className="strongText">{country.giPercentage < 0 ? 'NA' : country.giPercentage + '%'}</span> : ''}</TableCell>
                                        }
                                        <TableCell>
                                            {country.countryModuleMappingId !== 0 ?
                                                <span className="strongText">{country.coveragePercentage < 0 ? 'NA' : country.coveragePercentage + '%'}</span>
                                                : ''}
                                        </TableCell>
                                        <TableCell>
                                            {country.countryModuleMappingId !== 0 ?
                                                <span className="strongText">{country.forecastPercentage < 0 ? 'NA' : country.forecastPercentage + '%'}</span>
                                                : ''
                                            }    </TableCell>
                                    </TableRow>
                                }))
                                : (this.props.regionData && this.props.regionData.map((region: any, key: any) => {
                                    return <TableRow key={key}>
                                        <TableCell>
                                            <span>{region.name}</span>
                                        </TableCell>
                                        {
                                            !isGIAvailable ? '' : <TableCell><span className="strongText">{region.giPercentage < 0 ? 'NA' : region.giPercentage + '%'}</span> </TableCell>
                                        }
                                        <TableCell>
                                            <span className="strongText">{region.coveragePercentage < 0 ? 'NA' : region.coveragePercentage + '%'}</span>
                                        </TableCell>
                                        <TableCell>
                                            <span className="strongText">{region.forecastPercentage < 0 ? 'NA' : region.forecastPercentage + '%'}</span>
                                        </TableCell>
                                    </TableRow>
                                }))}
                        </TableBody>
                    </Table>
                </div>
                <div className="countryInfoFooter">
                    <div className="btn-groups alignWrapper">
                        <div className="alignLeft">
                            {
                                loggedInUser.roleId === UserType.DataManagerSupply || loggedInUser.roleId === UserType.DataManager
                                    || loggedInUser.roleId === UserType.DataManagerSupplyRegional || loggedInUser.roleId === UserType.DataManagerRegional || loggedInUser.roleId === UserType.DataCollector
                                    ?
                                    ''
                                    :
                                    <Button size="medium" className="btn-blue" onClick={this.downloadProgressReport} variant="outlined" type="button" value="Download Reports">
                                        Download Survey Progress Reports
                                    </Button>
                            }
                        </div>
                        <div className="grow" />
                        <div className="alignRight">
                            {
                                loggedInUser.roleId === UserType.DataCollector
                                    ?
                                    <Button size="medium" className="btn-blue-primary" variant="outlined" type="button" value="See Responses" onClick={this.gotoResponses}>
                                        Submit survey responses <ChevronRightIcon className="ChevronRightIcon" />
                                    </Button>
                                    :
                                    <Button size="medium" className="btn-blue-primary" variant="outlined" type="button" value="See Responses" onClick={this.gotoResponses}>
                                        See current survey responses <ChevronRightIcon className="ChevronRightIcon" />
                                    </Button>
                            }

                        </div>
                    </div>
                </div>
            </Grid>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/RegionCountryInfoComponent.tsx